const React = require('react');

/* eslint-disable */
module.exports = (props) => {
  return (
    <svg
      viewBox="0 0 18 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={'dB fillCT>path ' + (props.className || '')}
    >
      <path
        d="M17.1091 7.77732L10.2931 1.00932C10.1971 0.913323 10.1011 0.865323 10.0051 0.769323C9.95713 0.721323 9.90913 0.721323 9.86113 0.673323C9.81313 0.625323 9.76513 0.625323 9.66913 0.577323C9.62113 0.577323 9.57313 0.529323 9.47713 0.529323C9.42913 0.529323 9.38113 0.481323 9.33313 0.481323H9.04513C8.94913 0.481323 8.80513 0.481323 8.70913 0.529323C8.66113 0.529323 8.61313 0.577323 8.56513 0.577323C8.51713 0.577323 8.46913 0.625323 8.42113 0.625323C8.37313 0.625323 8.32513 0.673323 8.27713 0.721323C8.13313 0.721323 8.08513 0.769323 8.08513 0.769323C7.98913 0.817323 7.89313 0.913323 7.79713 1.00932L0.981125 7.77732C0.645125 8.11332 0.453125 8.54532 0.453125 9.02532C0.453125 9.50532 0.645125 9.93732 0.981125 10.2733C1.31713 10.6093 1.74913 10.8013 2.22913 10.8013C2.70913 10.8013 3.14113 10.6093 3.47713 10.2733L7.22113 6.52932L7.22113 21.7453C7.22113 22.7053 8.03713 23.5213 8.99713 23.5213C9.95713 23.5213 10.7731 22.7053 10.7731 21.7453L10.7731 6.52932L14.5171 10.2733C14.8531 10.6093 15.2851 10.8013 15.7651 10.8013C16.2451 10.8013 16.6771 10.6093 17.0131 10.2733C17.3491 9.93732 17.5411 9.50532 17.5411 9.02532C17.5891 8.59332 17.4451 8.11332 17.1091 7.77732Z"
      />
    </svg>
  );
};
